import { api } from './base.api.client'
import type { ExecutionResult } from '@/core/types/api.types'

export interface Capabilities {
  connection_id: string
  connector_id: string
  connector_name: string
  /** The only host this connection is permitted to reach. Enforced server-side. */
  base_url: string
  docs_url: string | null
  auth_type: string
  granted_scopes: string[]
  default_headers: Record<string, string>
  known_paths: string[]
}

export interface CustomRequest {
  method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'
  path: string
  query?: Record<string, unknown>
  headers?: Record<string, string>
  body?: unknown
  body_format?: 'json' | 'form' | 'none'
  paginate?: Record<string, unknown> | null
}

export const requestsApi = {
  capabilities: (connectionId: string) =>
    api.get<Capabilities>(`/connections/${encodeURIComponent(connectionId)}/capabilities`),

  /** Call any endpoint of the connected app through an authorized connection. */
  send: (connectionId: string, payload: CustomRequest, signal?: AbortSignal) =>
    api.post<ExecutionResult>(
      `/connections/${encodeURIComponent(connectionId)}/request`,
      payload,
      signal,
    ),
}
